import { faTags } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { formatSearchInRowToBold } from "../../../utils/misc";
import parse from 'html-react-parser';
import TAGS from "./Tags";

interface TagsListProps {
  tagsList: string[];
  search?: string;
  containerStyles?: {[key:string]:string};
  tagStyles?: {[key:string]:string};
}

const commonTagStyles = {
  margin: "4px",
  padding: "2px 5px",
  borderRadius: "5px"
};

function TagsList(props:TagsListProps) {
  const { tagsList, search } = props;
  const tagsIcon = <FontAwesomeIcon icon={faTags} fixedWidth></FontAwesomeIcon>;
  const getColorFromBackground = (red:number, green:number, blue:number):string => {
    /**
     * This formula come from:
     * https://stackoverflow.com/questions/3942878/how-to-decide-font-color-in-white-or-black-depending-on-background-color
     */
    if ((red*0.299 + green*0.587 + blue*0.114) > 186) {
      return "black";
    } else {
      return "white";
    }
  }
  const getTagColor = (tag:string) => {
    // default #007bff
    let red = 0, green = 123, blue = 255;
    switch(tag) {
      case "cpa":
        // greay
        red = 128;
        green = 128;
        blue = 128;
        break;
      case "cpc":
        // navy
        red = 0;
        green = 0;
        blue = 128;
        break;
      case "deeplink":
        // green
        red = 0;
        green = 128;
        blue = 0;
        break;
      case "deal-site":
        // darkcyan
        red = 0;
        green = 139;
        blue = 139;
        break;
      case "push":
        // purple
        red = 128;
        green = 0;
        blue = 128;
        break;
      case "pop":
        // red
        red = 255;
        green = 0;
        blue = 0;
        break;
      case "premium-whitelist":
        // silver
        red = 192;
        green = 192;
        blue = 192;
        break;
      default:
        break;
    }

    return {
      backgroundColor: `rgb(${red},${green},${blue})`,
      color: getColorFromBackground(red, green, blue)
    };
  }

  if (!tagsList) {
    return <></>;
  }

  const hardcodedTags = tagsList.filter((t) => TAGS.includes(t)).sort();
  const customTags = tagsList.filter((t) => !TAGS.includes(t)).sort();
  const sprtedTagsList = hardcodedTags.concat(customTags);

  return (
    <span style={{ margin: "4px 0", display: "flex", flexWrap: "wrap", alignItems: "center", ...props.containerStyles }}>
      {tagsIcon}

      {(() => {
        return (
          sprtedTagsList.map((tag, index) => {
          return (
            <span title={tag} key={index} style={{ ...getTagColor(tag), ...commonTagStyles, ...props.tagStyles }}>
              {search ? parse(formatSearchInRowToBold(tag, search)) : tag}
            </span>
          );
        }));
      })()}
    </span>
  );
}
export default TagsList;